export default {
  reverse: (params: URLSearchParams) => `https://nominatim.openstreetmap.org/reverse?${params.toString()}`,
  search: (params: URLSearchParams) => `https://nominatim.openstreetmap.org/search?${params.toString()}`,
};
